import type { E_ShareType } from '@eureka/services/src/types/share';

export interface ShareAuthCheckData {
    data_id: string;
    data_type: E_ShareType;
}

export interface ShareOwnerData {
    owner_id: string;
    owner_name: string;
}

export interface ShareLinkResponse {
    share_id: string;
}

export interface InviteByEmailData {
    share_id: string;
    share_emails: string[];
}

export enum ShareTaskStatus {
    PENDING = 300,
    SUCCESS = 200,
    FAILED = 500
}

export interface ExecuteShareTaskResponse {
    new_data_id: string;
    status: ShareTaskStatus;
}

export interface DuplicateModuleData {
    loading: boolean;
    status: ShareTaskStatus;
}

export interface ShareOwnerResponse {
    ownerId: string;
    ownerName: string;
}

export interface AuthModuleData {
    isShare: boolean;
    isLogin: boolean;
    ownerName: string;
    ownerId: string;
}

export interface AuthPageParams {
    currentDetailId: string;
    currentPageType: E_ShareType | '';
}

export interface ShareTrackData {
    source_type?: string;
    other_param?: string;
    event_detail_str?: string;
    module_type?: string;
    event_type?: string;
}
